import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import AccessReducer from '../reducers/AccessReducer';
import AppReducer from '../reducers/AppReducer';
const debug = Boolean(process.env.REACT_APP_DEBUG && true);
const store = configureStore({
    reducer: {
        AccessReducer,
        AppReducer,
    },
    middleware: [thunkMiddleware],
    devTools: debug,
});
export default store;
